module.exports = __webpack_public_path__ + "static/media/serverestlogo1.532833ba.png";